<div id="ecommerce-app">
  <mibp-dialog [registerForService]="true"></mibp-dialog>
  <mibp-inline-editing-overlay></mibp-inline-editing-overlay>
  <mibp-session-timeout></mibp-session-timeout>
  <mibp-loader type="fullscreen" isFullscreenGlobal="true"></mibp-loader>  

  <mibp-app-loader></mibp-app-loader>
  <mibp-toast-host></mibp-toast-host>
</div>
